import React, { useEffect, useState } from 'react';
import { func, instanceOf } from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';

const MapIndexRangeSettings = ({
  indexRange,
  excludeRange,
  // originalIndexRange,
  // handleIndexRangeChange
  mapSettings,
  runReport,
  updateMapSettings,
}) => {
  const exclude = mapSettings.exclude;
  const [min, setMin] = useState(indexRange[0]);
  const [max, setMax] = useState(indexRange[1]);
  const [excludeMin, setExcludeMin] = useState(excludeRange[0]);
  const [excludeMax, setExcludeMax] = useState(excludeRange[1]);

  useEffect(() => {
    setMin(indexRange[0]);
    setMax(indexRange[1]);
  }, indexRange);

  useEffect(() => {
    setExcludeMin(excludeRange[0]);
    setExcludeMax(excludeRange[1]);
  }, excludeRange);

  useEffect(() => {
    if (!exclude) {
      setExcludeMin('');
      setExcludeMax('');
    }
  }, [exclude]);

  const handleChange = (val, type) => {
    const updatedVal = val !== '' ? val.trim() : '';
    switch (type) {
      case 'min':
        setMin(updatedVal);
        break;
      case 'max':
        setMax(updatedVal);
        break;
      case 'excludeMin':
        setExcludeMin(updatedVal);
        break;
      case 'excludeMax':
        setExcludeMax(updatedVal);
        break;
      default:
    }
  };

  const applyIndexRange = () => {
    if (min && max) {
      const numMin = Number(min);
      const numMax = Number(max);
      const minIndex = numMin > numMax ? max : min;
      const maxIndex = numMax < numMin ? min : max;
      updateMapSettings('minIndex', minIndex);
      updateMapSettings('maxIndex', maxIndex);
    }
  };

  const resetIndexRange = () => {
    let updatedMapSettings = cloneDeep(mapSettings);
    updatedMapSettings = {
      ...updatedMapSettings,
      minIndex: undefined,
      maxIndex: undefined,
    };
    updateMapSettings('minIndex', undefined);
    updateMapSettings('maxIndex', undefined);
    runReport(undefined, undefined, undefined, undefined, updatedMapSettings);
  };

  const applyExcludeRange = () => {
    if (excludeMin && excludeMax) {
      const numMin = Number(excludeMin);
      const numMax = Number(excludeMax);
      const minExclude = numMin > numMax ? excludeMax : excludeMin;
      const maxExclude = numMax < numMin ? excludeMin : excludeMax;
      setExcludeMin(minExclude);
      setExcludeMax(maxExclude);
      updateMapSettings('excludeMinIndex', minExclude);
      updateMapSettings('excludeMaxIndex', maxExclude);
    }
  };

  const onChangeExclude = () => {
    if (exclude) {
      updateMapSettings('excludeMinIndex', undefined);
      updateMapSettings('excludeMaxIndex', undefined);
      updateMapSettings('exclude', false);
    } else {
      updateMapSettings('exclude', true);
    }
  };

  return (
    <div className="map--settings-indexRange">
      <div className="map--settings-indexRange__title">Index Range</div>
      <div className="map--settings-indexRange__wrapper">
        <input
          id="min"
          type="number"
          value={min}
          className="map--settings-indexRange__input"
          onChange={e => handleChange(e.target.value, 'min')}
        />
        -
        <input
          id="max"
          type="number"
          value={max}
          className="map--settings-indexRange__input"
          onChange={e => handleChange(e.target.value, 'max')}
        />
        <button
          id="includeApply"
          type="button"
          className="map--settings-indexRange__resetBtn"
          disabled={!min && !max}
          onClick={() => applyIndexRange()}
        >
          Apply
        </button>
        <button
          id="includeReset"
          type="button"
          className="map--settings-indexRange__resetBtn"
          onClick={() => resetIndexRange()}
        >
          Reset
        </button>
      </div>
      <div className="map--settings-exclude__wrapper">
        <div className="map--settings-exclude__checkWrap">
          <input
            type="checkbox"
            id="exclude"
            className="map--settings-exclude__checkbox"
            checked={exclude}
            onChange={() => onChangeExclude()}
          />
          Exclude
        </div>
        <div className="map--settings-exclude__inputWrap">
          <input
            id="excludeMin"
            type="number"
            value={excludeMin}
            className="map--settings-exclude__input"
            onChange={e => handleChange(e.target.value, 'excludeMin')}
            disabled={!exclude}
          />
          -
          <input
            id="excludeMax"
            type="number"
            value={excludeMax}
            className="map--settings-exclude__input"
            onChange={e => handleChange(e.target.value, 'excludeMax')}
            disabled={!exclude}
          />
          <button
            id="excludeApply"
            type="button"
            className="map--settings-exclude__resetBtn"
            disabled={!min && !max}
            onClick={() => applyExcludeRange()}
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

MapIndexRangeSettings.propTypes = {
  indexRange: instanceOf(Array),
  // originalIndexRange: instanceOf(Array),
  // handleIndexRangeChange: func,
  mapSettings: instanceOf(Object),
  runReport: func,
  updateMapSettings: func,
};

export default MapIndexRangeSettings;
